// Components/SlugChecker.jsx
import { useParams, Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import drEasyApi from "../../Api/Customapi";
import InternalServerError from "../Errors Handling/Error 500/InternalServerError";
import LockedDoctor from "../HomeSections/LockedDoctor";

const fetchDoctorBySlug = async (slug) => {
    const response = await drEasyApi.get(`/api/Doctor/GetDoctorBySlug/${slug}`);
    return response.data;
};

export default function SlugChecker() {
    const { slug } = useParams();

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['doctor', slug],
        queryFn: () => fetchDoctorBySlug(slug),
        retry: false,
    });

    if (isLoading) {
        return (
            <div className="h-screen flex items-center justify-center">
                <div className="size-14 border-primary border-y-2 rounded-full py-5 animate-spin" />
            </div>
        );
    }

    // Handle errors first
    if (isError) {
        if (error?.response?.status === 404) {
            return <Navigate to="/not-found" replace />;
        }
        return <InternalServerError />;
    }

    // Check if doctor data exists and has the required feature
    if (!data ) {
        return       <LockedDoctor/>   

    }

    // Provide doctor data as context
    return <Outlet context={data} />;
}